import { GridDefaults } from './Grid.constants';
import { AgGridReact } from 'ag-grid-react';
import React from 'react';
import { GridReadyEvent } from 'ag-grid-community';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';

const MultiSelectGrid = (props: any) => {
    const dataKey = props.dataKey;
    const immutableData =
        props.immutableData || (dataKey && GridDefaults.immutableData);

    const onGridReady = (params: GridReadyEvent) => {
        if (props.autofitColumns) {
            params.api.sizeColumnsToFit();
        }
        if (props.onGridReady) {
            props.onGridReady(params);
        }
    };

    return (
        <div
            className={'ag-theme-alpine ' + (props.gridClass || '')}
            style={props.gridStyle}
            data-testid={props.testId}>
            {props.displayToolbar && (
                <div className="action-bar">
                    {props.displayCreateNewButton && (
                        <Button
                            variant="text"
                            size="small"
                            onClick={props.onCreateNew}
                            startIcon={<AddCircleIcon />}>
                            Add New
                        </Button>
                    )}
                </div>
            )}
            <AgGridReact
                domLayout={props.domLayout}
                immutableData={immutableData}
                getRowNodeId={dataKey ? (data) => data[dataKey] : null}
                columnDefs={props.columnDefs}
                defaultColDef={props.defaultColDef}
                gridOptions={props.gridOptions}
                tooltipShowDelay={props.tooltipShowDelay}
                pagination={props.pagination}
                paginationPageSize={props.paginationPageSize}
                rowData={props.rowData}
                rowStyle={{
                    ...props.rowStyle,
                    cursor: 'pointer',
                }}
                headerHeight={props.headerHeight}
                onFirstDataRendered={props.onFirstDataRendered}
                onSortChanged={props.onSortChanged}
                onFilterChanged={props.onFilterChanged}
                onGridReady={onGridReady}
                frameworkComponents={props.frameworkComponents}
                onCellClicked={props.onCellClicked}
                rowSelection={'multiple'}
                onRowClicked={props.onRowClicked}
                onRowSelected={props.onRowSelected}
                masterDetail={props.masterDetail}
                suppressMenuHide={props.suppressMenuHide}
                rowMultiSelectWithClick={props.rowMultiSelectWithClick}>
                {props.children}
            </AgGridReact>
        </div>
    );
};

MultiSelectGrid.defaultProps = {
    domLayout: GridDefaults.domLayout,
    tooltipShowDelay: GridDefaults.tooltipShowDelay,
    pagination: GridDefaults.pagination,
    paginationPageSize: GridDefaults.paginationPageSize,
    autofitColumns: GridDefaults.sizeColumnsToFit,
    immutableData: GridDefaults.immutableData,
    displayToolbar: GridDefaults.displayToolbar,
};

export default MultiSelectGrid;
